import { useModal } from '../../../hooks/useDialog';
import useLocalization from '../../../hooks/useLocalization';
import BasePasswordForm, { PasswordFormData } from './BasePasswordForm';
import { useUpdatePassword } from '../../../mutations/useUpdatePassword';
import { useRoles } from '../../../hooks/useRoles';
import { useUpdateAgentData } from '../../../queries';
import { useParams } from 'react-router';

const UpdatePasswordForm = () => {
  const { t } = useLocalization();
  const { closeModal } = useModal();
  const { isPlayer } = useRoles();
  const { userId = '' } = useParams<{ userId: string }>();
  const { mutate: updateAgentData } = useUpdateAgentData(userId); // update BO user flow
  const { mutate: updatePassword, isPending: isSubmitting } = useUpdatePassword(); // update client user flow

  const onSubmit = (data: PasswordFormData) => {
    if (isPlayer) {
      updatePassword(data);
    } else {
      updateAgentData({ password: data.password });
    }
  };

  return (
    <BasePasswordForm
      onSubmit={onSubmit}
      onClose={closeModal}
      title={t('changePassword')}
      isSubmitting={isSubmitting}
    />
  );
};

export default UpdatePasswordForm;
